import { Component } from '@angular/core';

@Component({
  selector: 'app-second-section-landing',
  templateUrl: './second-section-landing.component.html',
  styleUrls: ['./second-section-landing.component.scss']
})
export class SecondSectionLandingComponent{

  constructor() { }

}
